import { render, staticRenderFns } from "./pageModel4.vue?vue&type=template&id=39c17150"
import script from "./pageModel4.vue?vue&type=script&lang=js"
export * from "./pageModel4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports